import { render, staticRenderFns } from "./AccountingCenterAnnouncementDialog.vue?vue&type=template&id=59650bca&"
import script from "./AccountingCenterAnnouncementDialog.vue?vue&type=script&lang=js&"
export * from "./AccountingCenterAnnouncementDialog.vue?vue&type=script&lang=js&"
import style0 from "./AccountingCenterAnnouncementDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports